import * as React from "react";
import { layoutWrapper } from "./Layout.module.scss";

export const LayoutWrapper: React.FC<any> = (props) => {
  return (
    <>
      <div className={layoutWrapper}>{props.children}</div>
    </>
  );
};

export const isPathExcluded = (
  path: string,
  excludedPaths: string[]
): boolean => {
  return excludedPaths.some((excludedPath: string) => {
    if (excludedPath.endsWith("/*")) {
      // Match prefix for wildcard paths
      const basePath = excludedPath.slice(0, -2); // Remove `/*`
      return path.startsWith(basePath);
    }
    return path === excludedPath;
  });
};
